import { useSelector } from '@ecommerce/nest-ssr/common';
import { CompanyInterface } from 'interfaces/company.interface';

export const useCompany = (): CompanyInterface => useSelector(
    (state: { company: CompanyInterface; }) => state.company
);
